import { array, boolean, object, string, type infer as zInfer } from "zod/v4";

export const brightpearlSalesCreditCustomFieldSchema = object({
  fieldKey: string().min(1, "Field name is required"),
  fieldValue: string().min(1, "Field value is required"),
});

export type BrightpearlSalesCreditCustomFieldInput = zInfer<
  typeof brightpearlSalesCreditCustomFieldSchema
>;

export const updateBrightpearlReturnsSettings = {
  name: "updateBrightpearlReturnsSettings" as const,
  input: object({
    customFieldsOnSalesCredit: array(
      brightpearlSalesCreditCustomFieldSchema,
    ).optional(),
  }),
  output: object({ success: boolean() }),
};
